// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2WrVn","buttons":"Footer_buttons__3XZ0H"};